var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/vue/vue": {
		getter: () => (__webpack_require__.e("vendors-node_modules_vue_dist_vue_runtime_esm-bundler_js").then(() => (() => (__webpack_require__("./node_modules/vue/dist/vue.runtime.esm-bundler.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	"webpack/sharing/consume/default/pinia/pinia": {
		getter: () => (__webpack_require__.e("vendors-node_modules_pinia_dist_pinia_mjs").then(() => (() => (__webpack_require__("./node_modules/pinia/dist/pinia.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "pinia",
	},
	"webpack/sharing/consume/default/vue3-click-away/vue3-click-away": {
		getter: () => (__webpack_require__.e("node_modules_vue3-click-away_dist_module_js").then(() => (() => (__webpack_require__("./node_modules/vue3-click-away/dist/module.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.2.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue3-click-away",
	},
	"webpack/sharing/consume/default/vue-demi/vue-demi": {
		getter: () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_vue"), __webpack_require__.e("node_modules_vue-demi_lib_index_mjs")]).then(() => (() => (__webpack_require__("./node_modules/vue-demi/lib/index.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue-demi",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_vue_vue": [
		"webpack/sharing/consume/default/vue/vue"
	],
	"webpack_sharing_consume_default_pinia_pinia": [
		"webpack/sharing/consume/default/pinia/pinia"
	],
	"src_bootloader_ts": [
		"webpack/sharing/consume/default/vue3-click-away/vue3-click-away"
	],
	"webpack_sharing_consume_default_vue-demi_vue-demi": [
		"webpack/sharing/consume/default/vue-demi/vue-demi"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}